<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
/>

<main class="tw-py-16 md:tw-py-20">
    <section class="tw-px-[5vw] md:tw-px-[7vw] tw-flex tw-flex-col tw-mt-5 md:tw-mt-16">
        <div class="tw-text-black tw-font-semibold tw-text-xs md:tw-text-2xl">
            {{'SME_PAGE.HERO.TITLE' | translate}}
        </div>
        <div class="tw-h-5"></div>
        <p class="tw-text-black md:tw-w-[55vw] tw-text-[11px] md:tw-text-base">
            {{'SME_PAGE.HERO.DESCRIPTION' | translate}}        
        </p>
    </section>

    <section class="tw-flex tw-flex-row tw-justify-between tw-mt-5 md:tw-mt-20 tw-px-[12vw] md:tw-px-[6vw] lg:tw-px-[14vw]">
        <div 
            class="
                tw-shadow-[0px_1px_3px_rgb(0,0,0,0.5)] tw-w-[80px] tw-h-[80px] md:tw-w-[221px] md:tw-h-[221px] 
                tw-flex tw-flex-col tw-justify-center tw-items-center tw-rounded-lg md:tw-rounded-3xl tw-cursor-pointer
                {{activeSection === supportItem.id && 'tw-border tw-border-[#FC932A]'}}
            "
            (click)="scroll(supportItem.id)"
            *ngFor="let supportItem of supportSections; index as i">
            <img 
                class="tw-w-[28px] md:tw-w-[94px]"
                [src]="supportItem.logoSrc"
                alt="Logo"
            />
            <span class="tw-text-black tw-font-medium tw-mt-2 md:tw-mt-5 tw-w-[70%] tw-text-center tw-text-[9px] md:tw-text-sm ">
                {{supportItem.title | translate}}
            </span>
        </div>
    </section>

    <section id="section1" class="tw-px-[6vw] tw-mt-24 md:tw-mt-32 tw-relative">
        <img 
            class="tw-mt-[-30px]"
            src="/assets/images/msme-flow-{{selectedLanguage}}.jpg"
            alt="Language"
        />
        <span class="tw-text-black tw-font-semibold tw-text-xs md:tw-text-2xl tw-absolute tw-top-0">
            {{'SME_PAGE.JOURNEY_SECTION.TITLE' | translate}}
        </span>
    </section>

    <section id="section2" class="tw-px-[6vw] tw-mt-12 md:tw-mt-0">
        <span class="tw-text-black tw-font-semibold tw-text-xs md:tw-text-2xl">
            {{'SME_PAGE.FA_SECTION.TITLE' | translate}}
        </span>
        <div class="tw-h-2"></div>
        <p class="tw-text-black md:tw-w-[55vw] tw-text-[11px] md:tw-text-base">
            {{'SME_PAGE.FA_SECTION.DESCRIPTION' | translate}}
        </p>
        <div class="tw-flex tw-justify-center tw-items-center">
            <img 
                class="tw-w-[600px] tw-mt-10"
                src="/assets/images/fa-team.jpg"
                alt="Fa Team"
            />
        </div>
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center md:tw-items-start tw-mt-14">
            <p class="tw-w-[200px] md:tw-w-[300px] tw-text-center tw-text-[11px] md:tw-text-xl tw-text-[#1E1E1E]">
                {{'SME_PAGE.FA_SECTION.ITEMS.0' | translate}}
            </p>
            <div class="tw-h-[1px] tw-bg-[rgba(0,0,0,0.2)] tw-w-[30vw] tw-mx-[auto] tw-my-5 md:tw-hidden"></div>
            <p class="tw-w-[200px] md:tw-w-[300px] tw-text-center tw-text-[11px] md:tw-text-xl tw-text-[#1E1E1E]">
                {{'SME_PAGE.FA_SECTION.ITEMS.1' | translate}}
            </p>
            <div class="tw-h-[1px] tw-bg-[rgba(0,0,0,0.2)] tw-w-[30vw] tw-mx-[auto] tw-my-5 md:tw-hidden"></div>
            <p class="tw-w-[200px] md:tw-w-[300px] tw-text-center tw-text-[11px] md:tw-text-xl tw-text-[#1E1E1E]">
                {{'SME_PAGE.FA_SECTION.ITEMS.2' | translate}}
            </p>
        </div>
        <div class="tw-h-[1px] tw-bg-[rgba(0,0,0,0.2)] tw-w-[70vw] tw-mx-[auto] tw-mt-14"></div>
    </section>

    <section id="section3" class="tw-px-[6vw] tw-mt-12 md:tw-mt-20">
        <span class="tw-text-black tw-font-semibold tw-text-xs md:tw-text-2xl">
            {{'SME_PAGE.GUIDE_SECTION.TITLE' | translate}}
        </span>
        <div class="tw-flex tw-flex-col tw-gap-12 md:tw-gap-20 tw-my-8">
            <div
                *ngFor="let guideItem of guide; index as i"
                class="tw-flex">
                <div class="
                    tw-shadow-[0px_1px_3px_rgb(0,0,0,0.5)] tw-w-[40px] tw-h-[40px] md:tw-w-[120px] md:tw-h-[120px] 
                    tw-flex tw-justify-center tw-items-center tw-rounded-md md:tw-rounded-2xl">
                    <img 
                        class="tw-w-[25px] md:tw-w-[71px]"
                        [src]="guideItem.icon"
                        alt="Guide item"
                    />
                </div>
                <div class="tw-ml-3 md:tw-ml-10 tw-flex tw-flex-col tw-flex-1">
                    <span class="tw-text-black tw-font-medium tw-text-xs md:tw-text-[22px]">
                        {{'SME_PAGE.GUIDE_SECTION.ITEMS.'+i+'.TITLE' | translate}}
                    </span>
                    <p class="mt-2 tw-text-black tw-text-[11px] md:tw-text-base">
                        {{'SME_PAGE.GUIDE_SECTION.ITEMS.'+i+'.CONTENT' | translate}}
                    </p>
                    <ol class="tw-list-decimal tw-ml-5 tw-mt-1">
                        <li
                            *ngFor="let item of guideItem.items; index as j"
                            class="tw-text-black tw-text-[11px] md:tw-text-base">
                            {{'SME_PAGE.GUIDE_SECTION.ITEMS.'+i+'.ITMES.'+j | translate}}
                        </li>
                    </ol>
                </div>  
            </div>
        </div>
        <p class="tw-text-black tw-text-[11px] md:tw-text-base">
            {{'SME_PAGE.GUIDE_SECTION.CONCLUDE_TEXT' | translate}}
            <a [routerLink]="['/business-financing']" class="tw-text-blue-700 tw-underline tw-font-medium">
                {{'SME_PAGE.GUIDE_SECTION.CONCLUDE_LINK' | translate}}
            </a>
        </p>
    </section>
</main>

<app-footer
    [selectedLanguage]="selectedLanguage"
/>
